import { Elm } from "./Main.elm";
import Assets from "./Assets.js";
import * as Page from "./Page.js";
import * as Credentials from "../../base/Credentials.js";
import * as Cache from "../../base/Cache.js";
import * as FileExtra from "../../base/File/Extra.js";
import * as Lang from "../../base/Lang.js";
import * as ToastPort from "../../ui/Ui/ToastPort.js";
import * as ModalPort from "../../ui/Ui/ModalPort.js";
import * as NewTab from "../../ui/Ui/NewTab.js";
import TasksI18n from "../i18n";
import BaseI18n from "../../base/i18n/index.js";
import ApiI18n from "../../api/i18n/index.js";
import UiI18n from "../../ui/i18n/index.js";

import "../styles/main.scss";

var app = Elm.Main.init({
  node: document.getElementById("app"),
  flags: {
    endpoint: window.endpoint,
    credentials: Credentials.getCredentials(),
    windowSize: { width: window.innerWidth, height: window.innerHeight },
    assets: Assets,
    lang: Lang.getLang() || navigator.language.slice(0, 2),
    i18n: [TasksI18n, BaseI18n, UiI18n, ApiI18n],
  },
});

Page.initPort(app);
Lang.initPort(app);
Credentials.initPort(app);
Cache.initPort(app);
FileExtra.initPort(app);
ToastPort.initPort(app);
ModalPort.initPort(app);
NewTab.initPort(app);

/* TODO: remove after patch https://github.com/elm/file/issues/17 */
const revokeObjectURL_ = URL.revokeObjectURL;
URL.revokeObjectURL = (x) => setTimeout(() => revokeObjectURL_(x), 5000);
